<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
    <template #FREIGHT="{ visible, params, close }">
      <BillDetails :row="params.row" :close="close" v-if="visible" />
    </template>
    <template #footer_bottom>
      <div
        style="font-size: 10px; color: rgb(204, 185, 185); text-align: right"
      >
        {{ $t("b2bDetailTip") }}
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  getB2BDetails,
  exportB2BDetails,
  createB2Bbill,
  getB2Bbill,
  syncB2Bbill,
  getB2BbillSplit,
  getB2BbillSplitDetail,
	getRate,
	saveRate,
} from "@/api/finance/b2b_details_hq";
import {
  getConfig,
} from "@/api/double/bill_hq";
import { getServiceDetail } from "@/api/double/list";
import { getCountry } from "@/api/system/country";
import { getB2bBillUSer } from "@/api/double/bill";
import { getService } from "@/api/double/list";
import { getUser } from "@/api/user/internal";
import expandRow from "./template/index";
import cTable from "@/base/common/index";
import BillDetails from "./details";
import copyClick from "@/utils/copyClick";
import { getSelectType, getKeysType } from "@/api/public";
import { getCompanies } from "@/api/user/client";
import { client_hq } from "@/api/finance/shipment_hq";
import {useModal} from '../b2b_bill_hq/rate.js'

export default {
  name: "b2b_details_hq",
  components: {
    cTable,
    BillDetails,
  },
  async mounted() {
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    let consignee = (await getService()).data.payload;
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    this.client_hq_list = (await client_hq()).data.payload;
		let data = (await getConfig()).data.payload;
		this.$refs["table"].currency = data.currency
    this.header.searchs.forEach((item) => {
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "consignee") item.options = consignee;
      if (item.key === "seller") item.options = salesman;
      if (item.key === "hq_client") item.options = this.client_hq_list;
    });
  },
  data() {
    return {
      client_hq_list: [],
      hq_clients: [],
      config: {
        children: true,
        rowId: "id",
        expandConfig: {
          accordion: true,
          lazy: true,
          visibleMethod: ({ row }) => {
            if (row.is_unpack === "YES") return true;
          },
          loadMethod({ row }) {
            return new Promise((resolve) => {
              let data = {
                packing_number: row.packing,
                airway_number: row.airway_bill_number,
              };
              getB2BbillSplitDetail(data).then((res) => {
                console.log(res);
                row["expand"] = res.data.status ? res.data.payload : [];
                resolve(row);
              });
            });
          },
        },
      },
      methods: {
        list: (data) => {
          let params = JSON.parse(JSON.stringify(data));
          if (data.hq_client) {
            params.hq_client = this.client_hq_list.reduce((a, b) => {
              this.hq_clients.find((t) => {
                if (t.value === b.uuid && t.label === b.account) {
                  a.push(b);
                  return true;
                }
              });
              return a;
            }, []);
          }
          return getB2BDetails(params);
        },
        getB2bBillUSer,
        exportB2BDetails,
        createB2Bbill,
        syncB2Bbill,
        getServiceDetail,
        getB2BbillSplit,
				getRate,
				b2bReStatistics:saveRate,
      },
      modals: {
				rate:useModal.call(this,'b2b_details_hq'),
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.shipment_id = this.$page.selectAll.map(
                (item) => item.shipment_id
              );
              this.$page
                .handleRequestMethods("createB2Bbill", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ name: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme"),
            },
          ],
        },
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = this.$page.selectAll.map((item) => {
                return item.airway_bill_number;
              });
              this.$page.handleRequestMethods("hang", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            title: this.$t("hang"),
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ remarks: 24 }],
          fields: [
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
            // {
            //   name: this.$t("Remarks"),
            //   key: "remarks",
            //   component: "Input",
            //   placeholder: () => this.$t("enter") + this.$t("Remarks")
            // },
            // {
            //   name: this.$t("type"),
            //   key: "types",
            //   component: "Radio",
            //   options: [
            //     { label: "总部", value: 1 },
            //     { label: "分公司", value: 2 },
            //     { label: "部门", value: 3 },
            //     { label: "岗位", value: 4 }
            //   ],
            //   bind: {
            //     border: true
            //   }
            // }
          ],
        },
        showFreight: {
          contentSlot: "FREIGHT",
          config: {
            modalBind: {
              width: 1550,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({ row }) {
                console.log(row);
                copyClick.copyToClipboard(row.airway_number, this);
              },
            },
          },
          footer: {
            show: () => false,
          },
          table: {
            height: 500,
          },
        },
        showUnPack: {
          config: {
            listFn: "getB2BbillSplit",
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            footer: {
              show: true,
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        ortherCostList: {
          config: {
            modalBind: {
              width: 60,
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;",
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500,
            },
            fields: [
              {
                name: () => this.$t("valueService") + this.$t("alipay_name"),
                key: "service_name",
                minWidth: 100,
              },
              {
                name: () => this.$t("Billing") + this.$t("noofpieces"),
                key: "quantity",
                align: "center",
                width: 100,
              },
              {
                name: () => this.$t("valueService") + this.$t("cost_t"),
                key: "total_amount",
                align: "center",
                width: 110,
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                align: "center",
                width: 100,
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "create_time",
                align: "center",
                width: 150,
              },
            ],
          },
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [
              { label: this.$t("outboundTime"), value: 1 },
              { label: this.$t("inboundTime"), value: 2 },
              { label: this.$t("InletTime"), value: 3 },
              { label: this.$t("finances") + this.$t("date"), value: 4 },
            ],
            default: 1,
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 },
            ],
          },
          {
            key: "hq_client",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("HQClient");
            },
            clearable: true,
            options: [],
            default: [],
            config: { label: "account", value: "uuid" },
            bind: {
              style: "width:200px",
              multiple: true,
              "max-tag-count": 1,
              "label-in-value": true,
            },
            methods: {
              "on-change": (data) => {
                this.hq_clients = data._value;
              },
            },
          },
          {
            key: "from_country",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code",
            },
          },
          {
            key: "seller",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label({ row }) {
                return row.realname
                  ? row.account + "(" + row.realname + ")"
                  : row.account;
              },
              value: "id",
            },
          },
          {
            key: "consignee",
            placeholder() {
              return this.$t("select") + this.$t(this.$t("company"));
            },
            component: "Select",
            options: [],
            config: {
              label: "service_name",
              value: "service_code",
            },
          },
          {
            key: "finance",
            placeholder() {
              return this.$t("whether") + this.$t("bindFreight");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "isUnpack",
            placeholder() {
              return this.$t("whether") + this.$t("unpack");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "is_create",
            placeholder() {
              return this.$t("whether") + this.$t("isOrder");
            },
            component: "Select",
            options: [
              {
                label: this.$t("YES"),
                value: "YES",
              },
              {
                label: this.$t("NO"),
                value: "NO",
              },
            ],
          },
          {
            key: "main_contract_header",
            placeholder() {
              return this.$t("select") + this.$t("preferential");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getB2Bbill()).data.payload;
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "department",
            placeholder() {
              return this.$t("select") + this.$t("assistDepartment");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["CLEARANCE_DEPARTMENT"])).data
                  .payload["CLEARANCE_DEPARTMENT"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getKeysType("B2B_OUTBOUND_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
              // id: 777,
            },
            {
              name: () => this.$t("synchronous"),
              type: "synchronous",
              fnName: "synchronousFn",
              bind: {
                icon: "md-refresh",
                type: "success",
              },
            },

            // {
            //   name: () => this.$t("hang"),
            //   type: "hang",
            //   fnName: "hang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            // {
            //   name: () => this.$t("cancel") + this.$t("hang"),
            //   type: "cancelHang",
            //   fnName: "cancelHang",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     // icon: "md-checkmark",
            //     type: "error"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              // id: 778,
              list: [
                {
                  name: "B2B" + this.$t("out") + this.$t("information"),
                  type: "1",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary",
                  },
                },
                {
                  name:
                    "B2B" +
                    this.$t("out") +
                    this.$t("information") +
                    "+" +
                    this.$t(" unpack") +
                    this.$t("information"),
                  type: "2",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary",
                  },
                },
              ],
            },
          ],
          methods: {
            export:({ searchForm, field }) => {
              let params = JSON.parse(JSON.stringify(searchForm));
              if (params.hq_client) {
                params.hq_client = this.client_hq_list.reduce((a, b) => {
                  this.hq_clients.find((t) => {
                    if (t.value === b.uuid && t.label === b.account) {
                      a.push(b);
                      return true;
                    }
                  });
                  return a;
                }, []);
              }
							let table =this.$refs['table']
              params["export"] = field.type;
              table.openLoading();
              table.handleRequestMethods(
                "exportB2BDetails",
                params,
                true,
                true
              ).then((res) => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            add:({ searchForm }) => {
							let params = JSON.parse(JSON.stringify(searchForm));
							if (params.hq_client) {
							  params.hq_client = this.client_hq_list.reduce((a, b) => {
							    this.hq_clients.find((t) => {
							      if (t.value === b.uuid && t.label === b.account) {
							        a.push(b);
							        return true;
							      }
							    });
							    return a;
							  }, []);
							}
              this.$refs['table'].getModal("add").open(params);
            },
            hang() {
              this.getModal("hang").open();
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelHangStatus", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
            synchronousFn() {
              this.$Modal.confirm({
                title: this.$t("synchronous"),
                width: 300,
                content:
                  this.$t("whether") +
                  this.$t("confirmOrder") +
                  this.$t("synchronous") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("syncB2Bbill", null, true).then(
                    (res) => {
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          width: 35,
          type: "expand",
          showOverflow: false,
          fixed: "left",
          expandRender: (h, p) => {
            return h(expandRow, {
              props: {
                row: p.row.expand,
              },
            });
          },
          fnName: "expandFun",
          methods: {
            expandFun({ row }) {
              console.log(row);
              return row.id;
            },
          },
        },
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("InletTime"),
          key: "confirmed_time",
          minWidth: 150,
          methods: {
            render({ value }) {
              return value ? this.format.timeFormat(value) : "-";
            },
          },
        },
        {
          name: () => this.$t("finances") + this.$t("date"),
          key: "finance_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          // component: "Button",
          width: 150,
          fixed: "left",
          bind: {
            type: "primary",
            size: "small",
          },
          copy: true,
          // methods: {
          //   render({ h, row }) {
          //     return row.airway_bill_number;
          //   },
          //   // click({ row }) {
          //   //   this.$page
          //   //     .getModal("showDetails")
          //   //     .setTitle(row.check_bill_number);
          //   //   // this.getModal("writeOff").type = "writeOff";
          //   //   this.$page.getModal("showDetails").open({ row });
          //   // }
          // },
        },
        {
          name: () => this.$t("CollectionUser"),
          align: "center",
          key: "target_type_txt",
          minWidth: 100,
          bind: {
            style({ row }) {
              if (row.target_type === 2) {
                return { color: "red" };
              }
            },
          },
        },
				{
				  name: () => this.$t("clientName"),
				  key: "client_name",
				  align: "left",
				  minWidth: 100,
				},
        {
          name: () => this.$t("actual_weight") + "KG",
          key: "actual_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("skuVolume") + "CBM",
          key: "charge_volume",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_params") + "KG",
          key: "charge_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("charge_volume") + "KG",
          key: "volume_weight",
          minWidth: 100,
        },
        {
          name: () => this.$t("valueService") + this.$t("cost_t"),
          key: "service_fee",
          width: 120,
          component: ({ row }) => (row.service_fee ? "Button" : "span"),
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            click({ row }) {
              if (row.service_fee) {
                this.$page
                  .handleRequestMethods(
                    "getServiceDetail",
                    row.airway_bill_number,
                    false,
                    true
                  )
                  .then((res) => {
                    this.$page
                      .getModal("ortherCostList")
                      .open(null, function () {
                        this.setTitle(
                          this.$t("valueService") + ":" + row.airway_bill_number
                        );
                        this.list = res.payload;
                      });
                  });
              }
            },
          },
        },
        {
          name: () => this.$t("otherCost") + "RMB",
          key: "other_cost",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "RMB",
          key: "freight",
          minWidth: 100,
        },
        {
          name: () => this.$t("otherCost") + "USD",
          key: "other_cost_usd",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "USD",
          key: "freight_usd",
          minWidth: 100,
        },
        {
          name: () => this.$t("otherCost") + "SAR",
          key: "other_cost_sar",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "SAR",
          key: "freight_sar",
          minWidth: 100,
        },
        {
          name: () => this.$t("otherCost") + "AED",
          key: "other_cost_aed",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "AED",
          key: "freight_aed",
          minWidth: 100,
        },
        {
          name: () => this.$t("otherCost") + "QAR",
          key: "other_cost_qar",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "QAR",
          key: "freight_qar",
          minWidth: 100,
        },
        {
          name: () => this.$t("otherCost") + "KWD",
          key: "other_cost_kwd",
          minWidth: 120,
        },
        {
          name: () => this.$t("freight_fees") + "KWD",
          key: "freight_kwd",
          minWidth: 100,
        },
        {
          name: () => this.$t("values"),
          minWidth: 100,
          key: "values",
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          width: 170,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          width: 170,
        },
        {
          name: () => this.$t("salesman"),
          align: "left",
          key: "sale_name",
          width: 150,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 160,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          align: "left",
          minWidth: 100,
          key: "shipper_company",
        },
        {
          name: () => this.$t("preferential"),
          align: "left",
          minWidth: 100,
          key: "main_contract_header_txt",
        },
        {
          name: () => this.$t("assistDepartment"),
          minWidth: 100,
          key: "department",
        },
        {
          name: () => this.$t(this.$t("company")),
          align: "left",
          minWidth: 100,
          key: "consignee",
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          width: 80,
        },
        {
          name: () => this.$t("to_station"),
          key: "warehouse",
          width: 80,
        },
        {
          name: () => this.$t("pretendNumber"),
          key: "quantity",
          width: 80,
        },
        {
          name: () => this.$t("deliver_goods_number"),
          key: "deliver_number",
          width: 80,
        },
        {
          name: () => this.$t("b2boutbound_number"),
          key: "outbound_number",
          width: 80,
        },
        {
          name: () => this.$t("b2b_remain_ticket"),
          key: "deliver_order",
          width: 80,
          methods: {
            render({ row }) {
              return (row.unpack_num - row.deliver_order).toString();
            },
          },
        },
        {
          name: () => this.$t("unpack") + this.$t("noofpieces"),
          key: "unpack_num",
          width: 80,
        },
        {
          name: () => this.$t("whether") + this.$t("unpack"),
          key: "is_unpack",
          width: 80,
          methods: {
            render({ value }) {
              return value == "YES" ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () =>
            this.$t("UnpackedFinished"),
          key: "isUnpack",
          width: 80,
          methods: {
            render({ value }) {
              return value == "YES" ? this.$t("YES") : this.$t("NO");
            },
          },
        },
        {
          name: () => this.$t("whether") + this.$t("isOrder"),
          key: "create_bill",
          width: 170,
					style(){
						return 'color:red'
					},
					render: (h, { row }) => {
					  if (row.bill_number) {
					    return h(
					      "a",
					      {
					        props: {
					          type: "warning",
					          size: "small"
					        },
					        on: {
					          click: () => {
					            this.$router.push({
					              name: "b2b_bill_hq"
					            });
					            this.$store.dispatch("pageUrl", row.bill_number);
					          }
					        }
					      },
					      row.bill_number
					    );
					  }else{
							return h('span',{},row['create_bill'])
						}
					},
					methods:{
						render({value,row}){
							return row.bill_number || value
						}
					}
        },
				{
				  name: () => this.$t("whether") + this.$t("is_solely"),
				  key: "is_solely",
				  width: 100,
					methods: {
					  render({ value }) {
					    return value == "YES" ? this.$t("YES") : this.$t("NO");
					  },
					},
				},
				{
				  name: () => this.$t("battery"),
				  key: "battery",
				  width: 80,
					methods: {
					  render({ value }) {
					    return value? this.$t("YES") : this.$t("NO");
					  },
					},
				},
				{
				  name: () => this.$t("whether") + this.$t("sticker"),
				  key: "is_lable",
				  width: 80,
					methods: {
					  render({ value }) {
					    return value? this.$t("YES") : this.$t("NO");
					  },
					},
				},
        {
          name: () => this.$t("bill_type"),

          key: "status_name",
          width: 80,
        },

        // {
        //   name: () => "财务人员",
        //
        //   key: "finance_account",
        //   width: 100
        // },
        {
          name: () => this.$t("from_country"),

          key: "from_country",
          width: 80,
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_code",
          width: 80,
        },
        {
          name: () => this.$t("warehouseName"),

          key: "warehouse_name",
          width: 80,
        },
        {
          name: () => this.$t("distribution_agent"),
          key: "dingcang_company",

          minWidth: 100,
        },
        {
          name: () => this.$t("customsBill"),
          key: "packing",

          minWidth: 100,
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",

          minWidth: 100,
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",

          width: 80,
        },
        {
          name: () => this.$t("status_time"),
          key: "status_time",

          minWidth: 170,
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
						{
						  name: this.$t("rate"),
						  type: "rate",
						  fnName: "rate",
						  bind: {
						    type: "warning",
						  },
						  disabled({ row }) {
						    return row.status == 4 || row.status == 8 || row.status == 9;
						  },
						  // id: 594,
						},
            {
              name: () => this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              bind: {
                type: "error",
              },
              afterIcon({ row }) {
                return (row.target_type == 2
                  ? row.branchFinancialTime > 0
                  : row.financeTime) > 0
                  ? "md-checkbox"
                  : "ios-square";
              },
            },
            // {
            //   name: () => this.$t("unpack") + this.$t("information"),
            //   type: "unpackmsg",
            //   fnName: "unpackmsgFn",
            //   bind: {
            //     type: "success"
            //   },
            //   show({ row }) {
            //     return row.is_unpack == "YES";
            //   }
            // }
          ],
          methods: {
						rate({ row }) {
							this.handleRequestMethods('getRate',row.id).then(res=>{
								console.log(res,'res');
								let rules = {USD:[],CNY:[],SAR:[],AED:[],QAR:[],KWD:[]}
								if(!Array.isArray(res.payload.curren_amount)){
									Object.keys(res.payload.curren_amount).map(t=>(
										rules[t] = [
											{
												required: true,
												type: "number",
												message: "cannot be empty",
												trigger: "blur",
											},
											{
												required: true,
												type: "number",
												message: "cannot less than 0.0001",
												trigger: "blur",
												min:0.0001,
												max:999999,
											},
										]
									))
								}
								Object.assign(this.modals.rate.config.rules || {},rules)
								this.getModal("rate").open({...res.payload.rate,id:row.id}, function () {
								  this.setTitle(row.airway_bill_number + "(" + this.$t("rate") + ")");
								});
							})

						},
            freight({ row }) {
              row.airway_number = row.airway_bill_number;
              this.getModal("showFreight").open({ row }, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("bindFreight") + ")"
                );
              });
            },
            // unpackmsgFn({ row }) {
            //   this.getModal("showUnPack").open(null, function() {
            //     this.setTitle(
            //       row.airway_bill_number +
            //         this.$t("unpack") +
            //         this.$t("information")
            //     );
            //     this.pageConfig.data = {
            //       airway_number: row.airway_bill_number
            //     };
            //     this.getList();
            //   });
            // }
          },
        },
      ],
    };
  },
};
</script>
